import React from 'react';
import {useTranslation} from "react-i18next";

import Page from "../Page";

import Card from "@mui/material/Card";
import StationAnalytics from "./StationAnalytics";
import useTabs from "../../components/TabsBar/useTabs";
import TabsBar from "../../components/TabsBar";
import Stack from "@mui/material/Stack";
import AvalanchesAnalytics from "./AvalanchesAnalytics";
import IncidentsAnalytics from "./IncidentsAnalytics";
import TabPanel from "../../components/TabsBar/TabPanel";


const Analytics = () => {
    const {t} = useTranslation(['analytics']);

    const tabs = useTabs({tabs: [
            {label: t("tabs.stations"), icon: "device_thermostat"},
            {label: t("tabs.avalanches"), icon: ""},
            {label: t("tabs.incidents"), icon: "report"}
        ]});

    const [selectedStation, setSelectedStation] = React.useState(null);
    const [selectedMicroZone, setSelectedMicroZone] = React.useState(null);

    return <Page>
        <Stack px={2} gap={2}>
            <TabsBar {...tabs}/>
            <Card sx={{p: 2}}>
                <TabPanel value={tabs.tabValue} index={0}>
                    <StationAnalytics selectedStation={selectedStation}
                                      setSelectedStation={setSelectedStation}/>
                </TabPanel>
                <TabPanel index={1} value={tabs.tabValue}>
                    <AvalanchesAnalytics selectedMicroZone={selectedMicroZone}
                                         setSelectedMicroZone={setSelectedMicroZone}/>
                </TabPanel>
                <TabPanel index={2} value={tabs.tabValue}>
                    <IncidentsAnalytics />
                </TabPanel>
            </Card>
        </Stack>
    </Page>
}

export default Analytics;